"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormAmountFields = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _placeOrderHelper = require("../../../helpers/placeOrderHelper");
var _FormItem = require("../../form/FormItem");
var _NumberInput = require("../../form/NumberInput");
var _decimalPlacesHelper = require("../../../helpers/decimalPlaces/decimalPlacesHelper");
var _APSelect = _interopRequireDefault(require("../../common/APSelect"));
var _pegPriceTypeConstants = require("../../../constants/sendOrder/pegPriceTypeConstants");
var _Slider = require("../../common/Slider/Slider");
var _useMoneyFields2 = require("../hooks/useMoneyFields");
var _useValidators2 = require("../../../constants/useValidators");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var breakpoints = [0, 25, 50, 75, 100];
var FormAmountFields = exports.FormAmountFields = function FormAmountFields(_ref) {
  var _instrument$Product2S, _instrument$Product2S2;
  var baseClass = _ref.baseClass,
    formName = _ref.formName,
    maxQuantity = _ref.maxQuantity,
    fieldLayout = _ref.fieldLayout,
    _ref$hasCredit = _ref.hasCredit,
    hasCredit = _ref$hasCredit === void 0 ? false : _ref$hasCredit;
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var _useValidators = (0, _useValidators2.useValidators)(),
    greaterThanOrEqualToZero = _useValidators.greaterThanOrEqualToZero,
    greaterThanZero = _useValidators.greaterThanZero,
    requiredNumeric = _useValidators.requiredNumeric;
  var _useMoneyFields = (0, _useMoneyFields2.useMoneyFields)(formName, maxQuantity, hasCredit),
    formValues = _useMoneyFields.formValues,
    sliderValue = _useMoneyFields.sliderValue,
    onSliderChange = _useMoneyFields.onSliderChange,
    valueDP = _useMoneyFields.valueDP,
    quantityDP = _useMoneyFields.quantityDP,
    instrument = _useMoneyFields.instrument,
    _onChange = _useMoneyFields.onChange,
    isBuy = _useMoneyFields.isBuy,
    isDisabled = _useMoneyFields.isDisabled;
  var anchoredField = formValues.anchoredField,
    orderType = formValues.orderType;
  var validateMaxQuantity = (0, _react.useCallback)(function (value) {
    if (hasCredit) {
      return;
    }
    var side = formValues.side == 0 ? 'Buy' : 'Sell';
    return value > maxQuantity ? t("".concat(side, " Amount exceeds the Max ").concat(side, " Amount. Please verify and try again.")) : undefined;
  }, [maxQuantity, formValues.side, t, hasCredit]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "order-entry--fields"
  }, (0, _placeOrderHelper.isStopPriceFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "stopPrice",
    placeholder: "0",
    className: baseClass,
    label: t('Stop Price'),
    symbol: (_instrument$Product2S = instrument === null || instrument === void 0 ? void 0 : instrument.Product2Symbol) !== null && _instrument$Product2S !== void 0 ? _instrument$Product2S : '',
    validate: [greaterThanZero],
    decimalPlaces: valueDP,
    layout: fieldLayout
  }), (0, _placeOrderHelper.isLimitPriceFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "limitPrice",
    placeholder: "0",
    className: baseClass,
    label: t('Limit Price'),
    symbol: (_instrument$Product2S2 = instrument === null || instrument === void 0 ? void 0 : instrument.Product2Symbol) !== null && _instrument$Product2S2 !== void 0 ? _instrument$Product2S2 : '',
    validate: [greaterThanZero],
    decimalPlaces: valueDP,
    layout: fieldLayout
  }), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.AmountInput,
    name: "quantity",
    placeholder: "0",
    className: baseClass,
    label: isBuy ? t('Buy Amount') : t('Sell Amount'),
    symbol: instrument.Product1Symbol,
    validate: [greaterThanZero, validateMaxQuantity],
    decimalPlaces: quantityDP,
    onFocus: function onFocus() {
      return _onChange('anchoredField', 'quantity');
    },
    isAprox: anchoredField === 'value',
    disabled: isDisabled,
    layout: fieldLayout
  }), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.AmountInput,
    name: "value",
    placeholder: "0",
    className: baseClass,
    label: t('Order Total'),
    symbol: instrument.Product2Symbol,
    validate: [greaterThanZero],
    decimalPlaces: valueDP,
    onFocus: function onFocus() {
      return _onChange('anchoredField', 'value');
    },
    isAprox: anchoredField === 'quantity',
    disabled: isDisabled,
    layout: fieldLayout
  }), /*#__PURE__*/_react["default"].createElement(_Slider.Slider, {
    disabled: isDisabled || hasCredit,
    onChange: onSliderChange,
    value: sliderValue,
    breakpoints: breakpoints,
    step: "0.01"
  }), (0, _placeOrderHelper.isTrailingAmountFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "trailingAmount",
    placeholder: "0",
    decimalPlaces: valueDP,
    label: t('Trailing Amount'),
    className: baseClass,
    symbol: instrument.Product2Symbol,
    validate: [greaterThanZero],
    layout: fieldLayout
  }), (0, _placeOrderHelper.isLimitOffsetFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "limitOffset",
    placeholder: "0",
    decimalPlaces: valueDP,
    label: t('Limit Offset'),
    className: baseClass,
    symbol: instrument.Product2Symbol,
    validate: [greaterThanZero],
    layout: fieldLayout
  }), (0, _placeOrderHelper.isPegPriceFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "pegPriceType",
    label: t('Peg Price'),
    customClass: baseClass,
    classModifiers: 'short',
    options: Object.keys(_pegPriceTypeConstants.pegPriceTypesNames).map(function (key) {
      return {
        value: key,
        label: _pegPriceTypeConstants.pegPriceTypesNames[key]
      };
    })
  }), (0, _placeOrderHelper.isDisplayQuantityFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "displayQuantity",
    placeholder: "0",
    decimalPlaces: (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.QuantityIncrement),
    label: t('Display Quantity'),
    customClass: baseClass,
    labelInInput: instrument.Product1Symbol,
    validate: [requiredNumeric, greaterThanOrEqualToZero],
    layout: fieldLayout
  }), (0, _placeOrderHelper.isTimeInForceFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "timeInForce",
    label: t('Time in Force'),
    customClass: baseClass,
    options: [{
      value: 1,
      label: t('Good Til Canceled')
    }, {
      value: 3,
      label: t('Immediate or Cancel')
    }, {
      value: 4,
      label: t('Fill or Kill')
    }],
    value: formValues.timeInForce,
    onChange: function onChange(e) {
      return _onChange('timeInForce', e.target.value);
    }
  }));
};